/**
 * API（GraphQL / Supabase 等）由来の日時を UNIX ミリ秒に変換する。
 *
 * `YYYY-MM-DDTHH:mm:ss[.fraction]` で **末尾に Z や ±offset が無い**文字列は、
 * `timestamptz` 等が **UTC** で返るケースが多いため **UTC として**解釈する。
 * そのまま `Date.parse` すると ECMAScript 実装により **ローカル時刻**扱いになり、
 * JST などで一覧の「○時間前」が最大約 9〜14 時間ずれる。
 */
export function parseApiTimestampToUnixMs(
  value: string | Date | null | undefined,
): number | undefined {
  if (value == null || value === '') {
    return undefined;
  }
  if (value instanceof Date) {
    const ms = value.getTime();
    return Number.isNaN(ms) ? undefined : ms;
  }

  const s = value.trim();
  if (s === '') {
    return undefined;
  }

  if (/[zZ]\s*$/.test(s)) {
    const ms = Date.parse(s);
    return Number.isNaN(ms) ? undefined : ms;
  }
  // 末尾が ±hh:mm または ±hhmm（タイムゾーンオフセット）
  if (/[-+]\d{2}:\d{2}\s*$/.test(s) || /[-+]\d{4}\s*$/.test(s)) {
    const ms = Date.parse(s);
    return Number.isNaN(ms) ? undefined : ms;
  }
  // `...T...` の線形日時で offset なし → UTC
  if (/^\d{4}-\d{2}-\d{2}T/.test(s)) {
    const ms = Date.parse(`${s}Z`);
    return Number.isNaN(ms) ? undefined : ms;
  }

  const ms = Date.parse(s);
  return Number.isNaN(ms) ? undefined : ms;
}
